import { render, staticRenderFns } from "./DomainBubble.vue?vue&type=template&id=46f2699c&scoped=true&"
import script from "./DomainBubble.vue?vue&type=script&lang=js&"
export * from "./DomainBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2699c",
  null
  
)

export default component.exports